import {
  type OrganizationGeneral,
  OrganizationGeneralSchema,
} from '@quromedical/models';
import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type { Fetcher } from 'design-system';
import type React from 'react';
import { useCallback, useState } from 'react';
import { strings } from 'strings';

import { createOrganizationGeneralRows } from './fields';

type General = OrganizationGeneral;

interface GeneralFormProps {
  data?: Partial<General>;
  handleSubmit: (data: OrganizationGeneral) => Promise<void>;
  handleCancel: () => void;
  schemeFetcher: Fetcher<string, unknown>;
}

export const GeneralForm: React.FC<GeneralFormProps> = ({
  data = {},
  handleCancel,
  handleSubmit,
  schemeFetcher,
}) => {
  const [state, setState] = useState<Partial<General>>(data);

  const fields = createOrganizationGeneralRows(schemeFetcher, state.type);
  const generalSchema = OrganizationGeneralSchema;

  const onSubmit = useCallback(
    async (data: OrganizationGeneral) => {
      try {
        await handleSubmit(data);
        return {};
      } catch (error) {
        return { error };
      }
    },
    [handleSubmit],
  );

  return (
    <CrudForm<General>
      key={state.type}
      title={strings.FormLabelPersonDetails}
      validationSchema={generalSchema}
      // casting to prevent complexity around the `schemeCode` field
      fields={fields as Field<OrganizationGeneral>[]}
      initialValues={state}
      onSubmit={onSubmit}
      onSecondarySubmit={handleCancel}
      onChange={setState}
      onChangeDebounceTime={0}
      showSecondarySubmitButton
      showSubmitButton
    />
  );
};
